"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/Certificates.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    marko_attrs0 = {
        "class": "my-1"
      },
    marko_attrs1 = {
        "class": ""
      },
    marko_attrs2 = {
        "class": "sub-body py-25"
      },
    marko_attrs3 = {
        "class": "list-inline"
      },
    marko_attrs4 = {
        "class": "p-50 my-50 cursor-pointer align-middle"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.list) && input.list.length) {
    out.be("div", marko_attrs0, "0", component);

    out.be("h5", marko_attrs1, "1", component);

    Locale_tag({
        text: "Certificates"
      }, out, __component, "2");

    out.ee();

    out.be("div", marko_attrs2, "3", component);

    out.be("ul", marko_attrs3, "4", component);

    var $for$0 = 0;

    marko_forOf(input.list, function({ poster, reference, versions }, index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      out.be("li", marko_attrs4, "5" + $keyScope$0, component);

      Image_tag({
          alt: reference,
          src: poster,
          class: "rounded",
          style: ("min-width:120px;height:" + (input.imageHeight || 120)) + "px",
          title: reference
        }, out, __component, "6" + $keyScope$0);

      out.ee();
    });

    out.ee();

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
